import Vue from "vue";
import Vuex from "vuex";
// Cargamos Vuex
Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    token: null
  },
  mutations: {
    load(state) {
      state.token = localStorage.getItem("token");
      console.log("cargando el storage token:" + state.token);
    }
  }, // mutations
  getters: {
    logged(state) {
      return state.user.token != "";
    }
  }
});

Vue.prototype.$store = store;
export default store;
